(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moesta-newsletter-choice"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){if(!document.querySelector(".mn-choice"))return;document.querySelectorAll("[id^=NewsletterPopup-]").forEach(function(popup){function close(){if(popup.classList.contains("modal--is-active")){var button=popup.querySelector(".modal__close");if(button)button.click();}}new MutationObserver(close).observe(popup,{attributes:true,attributeFilter:["class"]});close();});}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();document.addEventListener("shopify:section:load",init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moesta-rabatt"] && !Shopify.designMode) return;
  try {
    
(function(){function init(){if(!document.querySelector(".mr"))return;document.querySelectorAll("[id^=NewsletterPopup-]").forEach(function(popup){function close(){if(popup.classList.contains("modal--is-active")){var button=popup.querySelector(".modal__close");if(button)button.click();}}new MutationObserver(close).observe(popup,{attributes:true,attributeFilter:["class"]});close();});}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();document.addEventListener("shopify:section:load",init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sheriff-release-page"]) return;
  try {
    
(function () {
  /* COUNTDOWN */
  try {
    document.querySelectorAll('[data-countdown-target]').forEach(function (cd) {
      var raw = cd.getAttribute('data-countdown-target');
      var t = new Date(raw);
      if (isNaN(t.getTime())) return;
      var p = function (n) { return String(n).padStart(2,'0'); };
      var dEl = cd.querySelector('[data-cd-days]');
      var hEl = cd.querySelector('[data-cd-hours]');
      var mEl = cd.querySelector('[data-cd-minutes]');
      var sEl = cd.querySelector('[data-cd-seconds]');
      function tick() {
        var d = t - Date.now();
        if (d <= 0) {
          [dEl, hEl, mEl, sEl].forEach(function (el) { if (el) el.textContent = '00'; });
          return;
        }
        if (dEl) dEl.textContent = Math.floor(d/86400000);
        if (hEl) hEl.textContent = p(Math.floor(d%86400000/3600000));
        if (mEl) mEl.textContent = p(Math.floor(d%3600000/60000));
        if (sEl) sEl.textContent = p(Math.floor(d%60000/1000));
      }
      tick(); setInterval(tick, 1000);
    });
  } catch (e) { if (window.console) console.error('Sheriff countdown error:', e); }

  /* SCROLL REVEAL */
  try {
    var revealEls = document.querySelectorAll('.r, .rf');
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('v'); io.unobserve(e.target); } });
      }, { threshold: 0.1, rootMargin: '0px 0px -28px 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('v'); });
    }
  } catch (e) {
    if (window.console) console.error('Sheriff reveal error:', e);
    document.querySelectorAll('.r, .rf').forEach(function (el) { el.classList.add('v'); });
  }

  /* PARALLAX */
  try {
    var pxEls = document.querySelectorAll('[data-parallax]');
    if (pxEls.length) {
      window.addEventListener('scroll', function () {
        pxEls.forEach(function (pxEl) {
          var r = pxEl.parentElement.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          var factor = parseFloat(pxEl.getAttribute('data-parallax')) || 0.2;
          pxEl.style.transform = 'translate3d(0,' + ((window.scrollY - (r.top + window.scrollY)) * factor) + 'px,0)';
        });
      }, { passive: true });
    }
  } catch (e) { if (window.console) console.error('Sheriff parallax error:', e); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sheriff-sales-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function numeric(value, min, max) {
    const text = String(value ?? '').trim().replace(',', '.');
    const number = Number(text);
    if (!text || !Number.isFinite(number) || number < min || number > max) throw new RangeError('Invalid calculator input');
    return number;
  }
  function calculatePellets(input) {
    const temperature = numeric(input.temperature, 130, 310);
    const rate = {130: 0.34, 200: 0.70, 310: 0.99}[temperature];
    if (!rate) throw new RangeError('Unknown temperature');
    const hours = numeric(input.hours, 0.5, 24);
    const sessions = numeric(input.sessions, 1, 365);
    const years = numeric(input.years, 1, 10);
    const price = numeric(input.price, 0.01, 100);
    const sessionKg = rate * hours;
    const annualKg = sessionKg * sessions;
    const annualCost = annualKg * price;
    const result = { rate, temperature, hours, sessions, years, price, sessionKg, sessionCost: sessionKg * price, annualKg, annualCost, totalCost: annualCost * years, comparison: null };
    if (input.reference != null && String(input.reference).trim() !== '') {
      const reference = numeric(input.reference, 1, 10000);
      const total = reference / 1000 * hours * sessions * years * price;
      result.comparison = { reference, total, saving: total - result.totalCost };
    }
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { calculatePellets };
  if (typeof customElements === 'undefined' || customElements.get('sheriff-pellet-calculator')) return;

  class SheriffPelletCalculator extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controls = this.querySelector('fieldset');
      this.controls.disabled = false;
      this.money = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'});
      this.number = new Intl.NumberFormat('de-DE', {maximumFractionDigits: 2});
      this.addEventListener('input', event => {
        if (event.target.name === 'temperature') this.querySelector('[name="reference"]').value = '';
        this.update();
      });
      this.update();
    }
    update() {
      const input = Object.fromEntries(Array.from(this.querySelectorAll('[name]'), field => [field.name, field.value]));
      const results = this.querySelector('[data-results]');
      const error = this.querySelector('[data-error]');
      let result;
      try {
        result = calculatePellets(input);
        results.hidden = false;
        error.hidden = true;
      } catch (_) {
        results.hidden = true;
        error.hidden = false;
        return;
      }
      const values = {
        rate: this.number.format(result.rate * 1000),
        temperature: this.number.format(result.temperature),
        hours: this.number.format(result.hours),
        sessions: this.number.format(result.sessions),
        years: this.number.format(result.years),
        'session-kg': this.number.format(result.sessionKg),
        'session-cost': this.money.format(result.sessionCost),
        'annual-kg': this.number.format(result.annualKg),
        'annual-cost': this.money.format(result.annualCost),
        'total-cost': this.money.format(result.totalCost),
        'reference-cost': result.comparison ? this.money.format(result.comparison.total) : '',
        difference: result.comparison ? this.money.format(Math.abs(result.comparison.saving)) : ''
      };
      this.querySelectorAll('[data-value]').forEach(element => { element.textContent = values[element.dataset.value]; });
      this.querySelectorAll('[data-year-form]').forEach(element => { element.hidden = element.dataset.yearForm !== (result.years === 1 ? 'one' : 'many'); });
      this.querySelector('[data-comparison]').hidden = !result.comparison;
      this.querySelector('[data-comparison-empty]').hidden = !!result.comparison;
      const saving = result.comparison?.saving ?? 0;
      this.querySelectorAll('[data-sign]').forEach(element => {
        element.hidden = element.dataset.sign !== (Math.abs(saving) < 0.005 ? 'equal' : saving > 0 ? 'saving' : 'extra');
      });
    }
  }
  customElements.define('sheriff-pellet-calculator', SheriffPelletCalculator);
})();


if (!customElements.get('moesta-review-video')) {
  customElements.define('moesta-review-video', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button || this.dataset.ready) return;
      this.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const frame = this.querySelector('template').content.cloneNode(true);
        const stage = this.querySelector('.moesta-review__stage');
        stage.replaceChildren(frame);
        stage.querySelector('iframe').focus();
      }, {once: true});
    }
  });
}


document.addEventListener('click', function(event) {
  const link = event.target.closest('a[href^="#pellet-rechner-"]');
  if (!link) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  if (target && target.tagName === 'DETAILS') target.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sheriff2-content"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.s2c[data-section-id]').forEach(function (root) {
  if (root.dataset.s2cInit) return;
  root.dataset.s2cInit = "1";

  /* ---------- Accordion (Specs / Lieferumfang / FAQ) ---------- */
  root.querySelectorAll('[data-role="acc-head"]').forEach(function (head) {
    head.addEventListener('click', function () {
      head.parentElement.classList.toggle('s2c-acc-item--open');
    });
  });

  /* ---------- CTA-Buttons: zur Buybox nach oben scrollen ---------- */
  root.querySelectorAll('[data-role="cta-scroll"]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo(0, 0);
      }
    });
  });

  /* ---------- Pelletkosten-Rechner ---------- */
  var calcRoot = root.querySelector('.s2c-calc');
  if (!calcRoot) return;

  var cfg = calcRoot.dataset;
  var SHERIFF_G_H = parseFloat(cfg.sheriffGH) || 340;
  var REFERENCE_G_H = parseFloat(cfg.referenceGH) || 700;
  var PRICE = parseFloat(cfg.price) || 2.58;
  var GAS_KG_H = parseFloat(cfg.gasKgH) || 1.0;
  var GAS_PRICE = parseFloat(cfg.gasPrice) || 2.2;
  var defaultSessions = parseInt(cfg.defaultSessions, 10) || 20;
  var defaultHours = parseInt(cfg.defaultHours, 10) || 8;
  var defaultYears = parseInt(cfg.defaultYears, 10) || 3;
  var SAVINGS_PCT = Math.floor((1 - SHERIFF_G_H / REFERENCE_G_H) * 100 / 5) * 5;

  var sessionsInput = calcRoot.querySelector('[data-role="s-sessions"]');
  var hoursInput = calcRoot.querySelector('[data-role="s-hours"]');
  var yearsInput = calcRoot.querySelector('[data-role="s-years"]');
  var gasToggle = calcRoot.querySelector('[data-role="gas-toggle"]');
  var gasReveal = calcRoot.querySelector('[data-role="gas-reveal"]');

  function fmt(n, d) {
    d = d === undefined ? 0 : d;
    return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function euro(n) { return fmt(Math.round(n)) + ' €'; }
  function kg(n) { return fmt(Math.round(n)) + 'kg'; }
  function set(role, text) {
    var el = calcRoot.querySelector('[data-role="' + role + '"]');
    if (el) el.textContent = text;
  }

  function calc() {
    var sessions = parseInt(sessionsInput.value, 10);
    var hours = parseInt(hoursInput.value, 10);
    var years = parseInt(yearsInput.value, 10);

    set('v-sessions', fmt(sessions));
    set('v-hours', fmt(hours));
    set('v-years', fmt(years));

    sessionsInput.setAttribute('aria-valuenow', sessions);
    hoursInput.setAttribute('aria-valuenow', hours);
    yearsInput.setAttribute('aria-valuenow', years);

    var sheriffKgYear = (SHERIFF_G_H / 1000) * hours * sessions;
    var otherKgYear = (REFERENCE_G_H / 1000) * hours * sessions;
    var sheriffCostY = sheriffKgYear * PRICE;
    var otherCostY = otherKgYear * PRICE;
    var savingYear = otherCostY - sheriffCostY;
    var savingTotal = savingYear * years;
    var sheriffTotal = sheriffCostY * years;
    var otherTotal = otherCostY * years;

    set('r-sheriff', euro(sheriffTotal));
    set('r-other', euro(otherTotal));
    set('r-peryear', euro(savingYear));
    set('r-total', euro(savingTotal));

    var gasKgYear = GAS_KG_H * hours * sessions;
    var gasCostY = gasKgYear * GAS_PRICE;
    var gasTotal = gasCostY * years;
    set('r-gas', euro(gasTotal));

    set('c-sheriff-kg', kg(sheriffKgYear));
    set('c-other-kg', kg(otherKgYear));
    set('c-sheriff-cost', euro(sheriffCostY) + ' / Jahr');
    set('c-other-cost', euro(otherCostY) + ' / Jahr');

    var ratio = sheriffKgYear / otherKgYear;
    var barS = calcRoot.querySelector('[data-role="bar-s"]');
    var barO = calcRoot.querySelector('[data-role="bar-o"]');
    if (barS) barS.style.width = Math.round(ratio * 100) + '%';
    if (barO) barO.style.width = '100%';

    var yLabel = years === 1 ? 'Jahr' : 'Jahren';
    set('savings-head', 'Sparst du bis zu ' + SAVINGS_PCT + '%? In ' + fmt(years) + ' ' + yLabel + ' wären das:');
    set('big-saving', euro(savingTotal));
    set('fact-savings-pct', 'bis –' + SAVINGS_PCT + '%');
    set('fact-sheriff-gh', Math.round(SHERIFF_G_H) + 'g/h');
  }

  sessionsInput.addEventListener('input', calc);
  hoursInput.addEventListener('input', calc);
  yearsInput.addEventListener('input', calc);

  if (gasToggle && gasReveal) {
    gasToggle.addEventListener('click', function () {
      var isHidden = gasReveal.hasAttribute('hidden');
      if (isHidden) {
        gasReveal.removeAttribute('hidden');
        gasToggle.setAttribute('aria-expanded', 'true');
      } else {
        gasReveal.setAttribute('hidden', '');
        gasToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  sessionsInput.value = defaultSessions;
  hoursInput.value = defaultHours;
  yearsInput.value = defaultYears;
  calc();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
